import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@mui/material/Grid";
import { CheckBox } from "components/CheckBox/CheckBox";
import { DateTimePickerField } from "components/DateTime/DateTimePicker";
import { InputField } from "components/InputField/InputField";
import Loader from "components/loader/Loader";
import SearchComp from "components/Searchcomponent";
import { Template } from "components/Template/Template";
import { getDateTimeFormat, getDateTimeFormatForDatePicket, maskDateTime, toEtPickerDate, floorPickerTime } from "helper/dateFormat";
import { InfiniteScroll } from "helpers/InfiniteScroll/InfiniteScroll";
import CommunicationService from "Lib/API/Communication/index";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { setIsFromSelectedStep, setSelectedTemplate } from 'services/api/communication';
import { Footer } from "../../Footer/Footer";
import { PreviewTemplate } from "../PreviewTemplate/PreviewTemplate";
import {
  CampaignSectionWrapper,
  CheckBoxWrapper,
  NoContentWrapper,
  SearchWrapper,
  SelectTemplateSction,
  TemplateListContent,
  TemplateName,
  Title,
  Wrapper,
} from "../Theme";
const MyTemplateCreateCampain = ({
  formik,
  onNext,
  cardContent,
  setViewTemplate,
  viewTemplate,
  setActiveStep,
  onBack
}) => {
  const etNow = toEtPickerDate(new Date());
  const selectedDate = formik.values?.emailDate || null;
  const isToday = !selectedDate || new Date(selectedDate).toDateString() === etNow.toDateString();
  const minTime = isToday ? floorPickerTime(etNow) : new Date(etNow.getFullYear(), etNow.getMonth(), etNow.getDate(), 0, 0, 0, 0);
  const maxTime = new Date(etNow.getFullYear(), etNow.getMonth(), etNow.getDate(), 23, 59, 0, 0);
  const etNowMinutes = etNow.getHours() * 60 + etNow.getMinutes();
  const minDate = new Date(etNow.getFullYear(), etNow.getMonth(), etNow.getDate());
  const [sortBy, setSortBy] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const { getAccessTokenSilently } = useAuth0();
  const [hasMore, setHasMore] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch()
  const [search, setSearch] = useState({
    search: undefined,
  });
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [templateList, setTemplateList] = useState([]);
  const listRef = useRef(null);
  const lastScrollOffset = useRef(0);
  const {selectedTemplate,campaignEditData} = useSelector((state)=>state.communication)
  const buttons = viewTemplate
    ? [
        {
          name: "Previous",
          action: () => {
            setViewTemplate(false);
            dispatch(setIsFromSelectedStep(false))
          },
          isDisabled: false,
          type: "secondary",
          marginRight: "53rem",
          width: '100px',
          variant: "primary-outline",
        },
        {
          name: "Edit",
          action: () => {
            onNext();
            setViewTemplate(false);
            dispatch(setIsFromSelectedStep(false))
          },
          isDisabled: false,
          type: "secondary",
          width: '100px',
          variant: "primary",
        },
        {
          name: "Select",
          action: () => {setActiveStep(2)
            dispatch(setIsFromSelectedStep(true))
          },
          isDisabled: false,
          type: "primary",
          width: '100px',
          variant: "primary",
        },
      ]
    : [
        {
          name: "Previous",
          action: () => {
            onBack();
          },
          isDisabled:false,
          type: "secondary",
          width:'100px',
          marginRight: "53rem",
          variant: "primary-outline",
        },
        {
          name: "Next",
          action: () => {
            setViewTemplate(true);
          },
          width: '100px',
          isDisabled: Object.keys(campaignEditData)?.length !== 0 ?false : (
            Object.keys(selectedTemplate)?.length === 0 ||
            !formik.values?.campainName ||
            (formik?.values?.scheduledCampaign && !formik.values?.emailDate)),
          type: "primary",
          variant: "primary",
        },
      ];


      const dateTimeMask = maskDateTime();
      const placeholderFormat = getDateTimeFormat();
      const dateFormat = getDateTimeFormatForDatePicket()

  const getTempleteList = async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    const filterData = {
      search: search?.search,
      filter: {
        type: "communication"
    }
    };
    try {
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.getTemplateList(
        token,
        page,
        10,
        filterData
      );
      setCount(result?.pagination?.count);
      setTemplateList((prevList) => [...prevList, ...result?.result]);
      setPage((prevPage) => prevPage + 1);
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const debounceSearch = useCallback(
    debounce(() => {
      if (search) {
        getTempleteList();
      }
    }, 500),
    [search, sortBy, refresh]
  );
  useEffect(() => {
    if (searchValue === "") {
      setSearch({ search: undefined });
    } else {
      setSearch({ search: searchValue });
      setPage(1);
      setTemplateList([]);
    }
  }, [searchValue]);

  useEffect(() => {
    if (search) {
      debounceSearch();
    } else {
      getTempleteList();
    }
    return () => debounceSearch.cancel();
  }, [search, sortBy, refresh]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /[\*\(\)\+]/;
    if (!regex.test(inputValue)) {
      setSearchValue(inputValue);
    }
  };
  const itemCount = Math.ceil(templateList.length / 3);
  const handleScroll = ({
    scrollDirection,
    scrollOffset,
    scrollUpdateWasRequested,
  }) => {
    if (
      scrollDirection === "forward" &&
      !loading &&
      !scrollUpdateWasRequested
    ) {
      const totalHeight = 260 * itemCount; // Assuming item height is 320px
      if (scrollOffset > totalHeight - 630 * 2) {
        templateList.length !== count && getTempleteList();
      }
    }
    lastScrollOffset.current = scrollOffset;
  };

  useEffect(() => {
    if (listRef.current && lastScrollOffset.current) {
      listRef.current.scrollTo(lastScrollOffset.current);
    }
  }, [templateList]);
  const Row = ({ index, style }) => {
    return (
      <Grid container spacing={1} style={style}>
        {templateList.slice(index * 3, index * 3 + 3).map((template, idx) => (
          <Grid item xs={4} key={idx}>
            <Template
              selectedTemplate={campaignEditData?.template?._id === template?._id|| (selectedTemplate?._id === template?._id)}
              Content={
                <div
                  onClick={() => {
                    dispatch(setSelectedTemplate(template))
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={template?.thumbnail}
                    alt="Not Found"
                    style={{
                      minWidth: "167px",
                      width: "167px",
                      minHeight: "150px",
                      height: "150px",
                    }}
                  />
                  <TemplateName>
                    <span>{template?.title}</span>
                  </TemplateName>
                </div>
              }
            />
          </Grid>
        ))}
      </Grid>
    );
  };

  const handleDateChange = (newDate) => {
    if (!newDate) {
      formik.setFieldValue(`emailDate`, null);
      return;
    }
    const etNowTime = toEtPickerDate(new Date());
    const newDateTime = new Date(newDate);

    if (newDateTime.getHours() === 0 && newDateTime.getMinutes() === 0) {
      newDateTime.setHours(etNowTime.getHours());
      newDateTime.setMinutes(etNowTime.getMinutes());
    }
    formik.setFieldValue("emailDate", newDateTime);
  };
  
  return (
    <>
      {viewTemplate ? (
        <PreviewTemplate selectedTemplate={selectedTemplate} campaignEditData={campaignEditData}/>
      ) : (
        <>
          {" "}
          <Title>Create Campaign</Title>
          <CampaignSectionWrapper>
            <InputField
              mandatory
              label={`Campaign Name`}
              type="text"
              formik={formik}
              value={formik.values?.campainName}
              message={"Please enter valid email"}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              style={{
                width: "312px",
                height: "48px",
              }}
              styleWrapper={{
                display: "flex",
                flexDirection: "column",
                paddingLeft: "1px",
                justifyContent: "center",
              }}
              Wrapper={{ alignItems: "baseline" }}
              labelStyle={{
                color: "#002E5C",
                fontSize: "14px",
                fontWeight: 400,
              }}
              onChange={(e) => {
                formik.setFieldValue("campainName", e.target.value);
              }}
            />
            <CheckBoxWrapper>
              <CheckBox
                checked={formik?.values?.scheduledCampaign}
                onChange={(e) => {
                  formik.setFieldValue(
                    "scheduledCampaign",
                    e.target.checked
                  );
                  formik.setFieldValue("emailDate", null);
                }}
                text="Scheduled Campaign"
              />
            </CheckBoxWrapper>
          </CampaignSectionWrapper>
          <br />
          {formik?.values?.scheduledCampaign && (
            <div style={{ width: "80%" }}>
              <hr />
              <DateTimePickerField
                mandatory={true}
                showIcon
                {...{
                  formik,
                  title: "Campaign date/time (ET timezone) ",
                  name: "emailDate",
                }}
                checkValidation={true}
                selected={selectedDate}
                onChange={(e)=>
                  handleDateChange(e)
                  
                }
                minDate={minDate}
                minTime={minTime}
                maxTime={maxTime}
                filterTime={isToday ? (time) => time.getHours() * 60 + time.getMinutes() >= etNowMinutes : undefined}
                showTimeSelect={true}
                dateFormat={dateFormat}
                placeholderText={placeholderFormat}
                mask={dateTimeMask}
                
              />
            </div>
          )}
          <SelectTemplateSction>
            <Title>
              Select Template
              <label style={{ fontWeight: "500", color: "red" }}>{" *"}</label>
            </Title>
            <br />
            <SearchWrapper>
              <SearchComp
                value={searchValue}
                setSearchText={handleInputChange}
                placeholder="Search"
                style={{
                  width: "312px",
                  height: "48px !important",
                  backgroundColor: "#fff",
                }}
              />
            </SearchWrapper>
            <br />
            <TemplateListContent>
              <div>
                <InfiniteScroll
                  height={213}
                  itemCount={itemCount}
                  itemSize={200}
                  width="100%"
                  onScroll={handleScroll}
                  ref={listRef}
                >
                  {Row}
                </InfiniteScroll>
                {loading && (
                  <NoContentWrapper style={{ height: "320px" }}>
                    <Loader />
                  </NoContentWrapper>
                )}
              </div>
            </TemplateListContent>
          </SelectTemplateSction>
          <br />
        </>
      )}
      <Footer type={cardContent} buttons={buttons}
         Wrapperstyle={{
          width:'84%',
          justifyContent: "center",
          marginButton: "10px",
        }}
      />
      <br />
    </>
  );
};

export default MyTemplateCreateCampain;
